import React, { useRef, useState, useEffect } from 'react';
import useAuth from '../Hooks/useAuth';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { Row, Col, Spinner, FormGroup, Label, Input, Button, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Navbar } from 'reactstrap';
import './Login.css';
import './Signup.css';
import SignupFooter from '../../../images/SignupFooter_1.png';
import headerImage from '../../../images/SignupHeader.png';
import { FaCross, FaTrash,FaEdit } from 'react-icons/fa';
import SpinnerContainer from '../../Utilities/Ui/SpinnerContainer';
import uuid from 'react-uuid';
import toast, { Toaster } from 'react-hot-toast';
import Loading from 'react-fullscreen-loading';
import './Stripe.css';
const Signup = () => {
    const [loading, setLoading] = useState(true); const [formErrors, setFormErrors] = useState({});
    const [farmErrors, setFarmErrors] = useState([]); const [transactionLoading, setTransactionLoading] = useState(false);
    const [signupForm, setSignupForm] = useState({ firstName: '', surName: '', email: '', mobilePhone: '' });
    const [farmRows, setFarmRows] = useState([]); const [catchmentList, setCatchmentList] = useState([]);
    const [regionalCouncilList, setRegionalCouncilList] = useState([]);
    const [annual, setAnnual] = useState(true); const [monthly, setMonthly] = useState(false); const [conditions, setConditions] = useState(false);
    const [annualCharge, setAnnualCharge] = useState(199); const [monthlyCharge, seMonthlyCharge] = useState(18.24); const [gst, seGST] = useState(15);
    const [invoiceInfo, setInvoiceInfo] = useState({
        description: "",
        price: annualCharge, userinfo: signupForm, farmsInfo: farmRows
    });
    const [propertyPopup, setPropertyPopup] = useState({
        showPropertyPopup: false, id: 0, name: '', address1: '', address2: '', city: '', postCode: '', regionalCouncil:0,catchment:0,isErrorRow:false
    }); const [popupErrors, setPopupErrors] = useState({});
    const [isAutoRenew, setAutoRenew] = useState(true);
    const populateItemData = async () => {
        try {
            const response = await axios.get(
                '/api/auth/Signup/', {
                params: {}
            }
            );
            setCatchmentList(response.data.content.catchments);
            setRegionalCouncilList(response.data.content.regionalCouncils);
            const item = {
                name: "", address1: "", address2: "", city: "", email: "", id: 0, postCode: '', regionalCouncil: 0, catchment: 0
            };
            const tempRows = [...farmRows];
            tempRows.push(item);
            setFarmRows([...farmRows, item]);
            var farmsCount = farmRows.length + 1;
            var totalAmount = 0;
            totalAmount = farmsCount > 0 ?
                (annual == true ? (farmsCount > 0 ? (farmsCount * annualCharge) + (Math.round((farmsCount * annualCharge * (gst / 100)) * 100) / 100) : 0) : (monthly == true ? (farmsCount > 0 ? Math.round(((farmsCount * monthlyCharge) + ((farmsCount * monthlyCharge) * (gst / 100))) * 100) / 100 : 0) : 0))
                : 0;
            setInvoiceInfo({
                ...invoiceInfo, description: farmsCount + ' farms', price: totalAmount, farmsInfo: tempRows
            })
            const error = {
                name: '', address1: '', address2: '', city: '', postCode: '', regionalCouncil: '', catchment: ''
            };
            setFarmErrors([...farmErrors, error]);
            setAnnualProductId(response.data.content.stripeAnnualProductId);
            setMonthlyProductId(response.data.content.stripeMonthlyProductId);
            setLoading(false);
        }
        catch
        {
        }
    }
    const [annualProductId, setAnnualProductId] = useState('');
    const [monthlyProductId, setMonthlyProductId] = useState('');

    let [success, setSuccess] = useState(false);
    let [sessionId, setSessionId] = useState('');
    let [message, setMessage] = useState('');

    useEffect(() => {
        setLoading(true);
        populateItemData();
        const query = new URLSearchParams(window.location.search);
        if (query.get('success')) {
            setSuccess(true);
            setSessionId(query.get('session_id'));
        }
        if (query.get('canceled')) {
            setSuccess(false);
            setMessage(
                "Order canceled -- continue to shop around and checkout when you're ready."
            );
        }
    }, []);

    const BackToMainPage = async () => {
        window.open("https://freshwaterfarmplan.co.nz/pricing/", "_self");
    }
    const BackToSupportGuides = async () => {
        window.open("https://support.freshwaterfarmplan.co.nz/", "_blank");
    }
    const BackToTerms = async () => {
        window.open("https://freshwaterfarmplan.co.nz/terms-and-conditions-qconzfwfp-tool/", "_blank");
    }
    const CreateCheckoutSession = async () => {
        setSaving(true)
        var form =
        {
            UserInfo: signupForm,
            FarmInfo: [...farmRows],
            ProductId: annual == true ? annualProductId : (monthly == true ? monthlyProductId : ''),
            SubscriptionType: annual == true ? 'Annual' : (monthly == true ? 'Monthly' : ''),
            IsSubscription: isAutoRenew
        };
        var response = await axios.post(
            '/api/create-checkout-session/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            setSaving(false);
            if (response.data.status) {
                window.open(response.data.content, "_self");
            }
        }
    }

    const handlefarmRowsAddRow = () => {
        const item = {
            name: "", address1: "", address2: "", city: "", email: "", id: 0,postCode:'',regionalCouncil:0,catchment:0
        };
        const tempRows = [...farmRows];
        tempRows.push(item);
        setFarmRows([...farmRows, item]);
        var farmsCount = farmRows.length + 1;
        var totalAmount = 0;
        totalAmount = farmsCount > 0 ?
            (annual == true ? (farmsCount > 0 ? (farmsCount * annualCharge) + (Math.round((farmsCount * annualCharge * (gst / 100)) * 100) / 100) : 0) : (monthly == true ? (farmsCount > 0 ? Math.round(((farmsCount * monthlyCharge) + ((farmsCount * monthlyCharge) * (gst / 100))) * 100) / 100 : 0) : 0))
            : 0;
        setInvoiceInfo({
            ...invoiceInfo, description: farmsCount + ' farms', price: totalAmount, farmsInfo: tempRows
        })
        const error = {
            name: '', address1: '', address2: '', city: '', postCode: '', regionalCouncil: '', catchment:''
        };
        setFarmErrors([...farmErrors, error]);
    };

    const handlefarmRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...farmRows]
        tempRows.splice(idx, 1)
        setFarmRows(tempRows);
        var farmsCount = farmRows.length - 1;
        var totalAmount = 0;
        totalAmount = farmsCount > 0 ? (annual == true ? (farmsCount > 0 ? farmsCount * annualCharge : 0) : (monthly == true ? (farmsCount > 0 ? (Math.round(farmsCount * { monthlyCharge } * 100) / 100) : 0) : 0)) +
            (annual == true ? (farmsCount > 0 ? Math.round((farmsCount * annualCharge * (gst / 100)) * 100) / 100 : 0) : (monthly == true ? (farmsCount > 0 ? (Math.round((Math.round(farmsCount * { monthlyCharge } * 100) / 100) * (gst / 100) * 100) / 100) : 0) : 0))
            : 0;
        setInvoiceInfo({ ...invoiceInfo, description: farmsCount + ' farms', price: totalAmount, farmsInfo: tempRows })
        const tempErrors = [...formErrors];
        tempErrors.splice(idx, 1)
        setFarmErrors(tempErrors);
    }
    const handlePropertyNameChange = idx => e => {
        const tempRows = [...farmRows];
        tempRows[idx].name = e.target.value;
        setFarmRows(tempRows);
    };
    const handlePropertyAddress1Change = idx => e => {
        const tempRows = [...farmRows];
        tempRows[idx].address1 = e.target.value;
        setFarmRows(tempRows);
    };
    const handlePropertyAddress2Change = idx => e => {
        const tempRows = [...farmRows];
        tempRows[idx].address2 = e.target.value;
        setFarmRows(tempRows);
    };
    const handlePropertyCityChange = idx => e => {
        const tempRows = [...farmRows];
        tempRows[idx].city = e.target.value;
        setFarmRows(tempRows);
    };
    const handlePropertyPostCodeChange = idx => e => {
        const tempRows = [...farmRows];
        tempRows[idx].postCode = e.target.value;
        setFarmRows(tempRows);
    };
    const handlePropertyCatchmentChange = idx => e => {
        const tempRows = [...farmRows];
        tempRows[idx].catchment = parseInt(e.target.value);
        setFarmRows(tempRows);
    };
    const handlePropertyRegionalCouncilChange = idx => e => {
        const tempRows = [...farmRows];
        tempRows[idx].regionalCouncil = parseInt(e.target.value);
        setFarmRows(tempRows);
    };
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    const validateForm = async () => {
        setFormErrors({});
        const tempErrors = [...farmErrors];
        const farmList = [...farmRows];
        const errors = {};
        var farmErrorFound = false;
        for (var i = 0; i < farmList.length; i++) {
            if (!farmList[i].name) {
                tempErrors[i].name = 'This field is mandatory';
                farmErrorFound = true;
            }
            if (!farmList[i].address1) {
                tempErrors[i].address1 = 'This field is mandatory';
                farmErrorFound = true;
            }
            //if (!farmList[i].address2) {
            //    tempErrors[i].address2 = 'This field is mandatory';
            //    farmErrorFound = true;
            //}
            if (!farmList[i].city) {
                tempErrors[i].city = 'This field is mandatory';
                farmErrorFound = true;
            }
            if (!farmList[i].postCode) {
                tempErrors[i].postCode = 'This field is mandatory';
                farmErrorFound = true;
            }
            //if (farmList[i].regionalCouncil == 0) {
            //    tempErrors[i].regionalCouncil = 'This field is mandatory';
            //    farmErrorFound = true;
            //}
            //if (farmList[i].catchment == 0) {
            //    tempErrors[i].catchment = 'This field is mandatory';
            //    farmErrorFound = true;
            //}
        }
        setFarmErrors(tempErrors);
        if (!signupForm.firstName) {
            errors.firstName = "This field is mandatory";
        }
        if (!signupForm.surName) {
            errors.surName = "This field is mandatory";
        }
        
        if (!signupForm.email) {
            errors.email = "This field is mandatory";
        }
        else {
            if (!signupForm.email.match(isValidEmail)) {
                errors.email = "Email is not in correct format";
            }
        }
        if (!signupForm.mobilePhone) {
            errors.mobilePhone = "This field is mandatory";
        }
        setFormErrors(errors);
        if (farmList.length == 0) {
            farmErrorFound = true;
        }
        if (Object.keys(errors).length > 0 || farmErrorFound) {
            return false;
        }
        else {
            return true;
        }
    }

    const handleChangeConditions  = async(e) => {
        var checkboxValue = e.target.checked;
        if (e.target.checked) {
            var result = await validateForm();
            if (result == false) {
                toast.error("Fill the mandatory fields before proceed to payment!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
            else {
                setConditions(checkboxValue)
            }
        }
        else {
            setConditions(checkboxValue)
        }
    }

    const handleMonthlyChange = async (e) => {
        var checkboxValue = e.target.checked;
        setMonthly(checkboxValue);
        if (checkboxValue) (setAnnual(false))
        var totalAmount = 0;
        totalAmount = checkboxValue == true ? (farmRows.length > 0 ? Math.round(((farmRows.length * monthlyCharge) + ((farmRows.length * monthlyCharge) * (gst / 100))) * 100) / 100 : 0) : 0;
        setInvoiceInfo({
            ...invoiceInfo, description: farmRows.length + ' farms', price: totalAmount, farmsInfo: farmRows
        })
    }

    const handleAnnualChange = async (e) => {
        var checkboxValue = e.target.checked;
        setAnnual(checkboxValue);
        if (checkboxValue) (setMonthly(false))
        var totalAmount = 0;
        totalAmount = checkboxValue == true ? (farmRows.length > 0 ? (farmRows.length * annualCharge) + (Math.round((farmRows.length * annualCharge * (gst / 100)) * 100) / 100) : 0) : 0;
        setInvoiceInfo({
            ...invoiceInfo, description: farmRows.length + ' farms', price: totalAmount, farmsInfo: farmRows
        })
    }

    const onSuccessPayment = async (order) => {
        var form =
        {
            UserInfo: signupForm,
            FarmInfo: [...farmRows],
            PaymentInfo: {}
        };
        var PaymentInfo = {
            Subscription: annual == true ? 'Annual' : (monthly == true ? 'Monthly' : ''), OrderId: order.id, PayerId: order.payer.payer_id,
            Amount: annual == true ? (farmRows.length > 0 ? farmRows.length * annualCharge : 0) : (monthly == true ? (farmRows.length > 0 ? (Math.round(farmRows.length * monthlyCharge * 100) / 100) : 0) : 0),
            Gst: annual == true ? (farmRows.length > 0 ? Math.round((farmRows.length * annualCharge * (gst / 100)) * 100) / 100 : 0) : (monthly == true ? (farmRows.length > 0 ? (Math.round((Math.round(farmRows.length * monthlyCharge * 100) / 100) * (gst / 100) * 100) / 100) : 0) : 0)
        }
        form.PaymentInfo = PaymentInfo;
        const response = await axios.post(
            '/api/auth/OnSignupSuccess/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            setTransactionLoading(false);
            if (response.data.status) {
                toast.success("Payment successful and details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setTimeout(() => {
                    window.open("/signupthanks", "_self");
                }, 3000);
            }
        }
    }

    const paypalSubscribe = (data, actions) => {
        return actions.subscription.create({
            'plan_id': "P-54D06055YB497834NMXUMFCA",
        });
    };
    const paypalOnError = (err) => {
        console.log("Error")
    }
    const paypalOnApprove = (data, detail) => {
        // call the backend api to store transaction details
        console.log("Payapl approved")
        console.log(data.subscriptionID)
    };
    const handlePropertyPopupOpen = (idx) => () => {
        var property = farmRows.filter((element, index) => index == idx);
        if (property.length > 0) {
            setPropertyPopup({
                ...propertyPopup, showPropertyPopup: true, id: idx, name: property[0].name, address1: property[0].address1, address2: property[0].address2, city: property[0].city
                , postCode: property[0].postCode, regionalCouncil: null, catchment: null//, isErrorRow:idx ==  0 ? false : true
            })
        }
    }
    const handlePropertyPopupClose = () => {
        setPropertyPopup({ ...propertyPopup, showPropertyPopup: false, id: 0 })
    }
    const handlePropertyPopupSave = () => {
        setPopupErrors({});
        const errors = {};
        if (!propertyPopup.name) {
            errors.name = "This field is mandatory";
        }
        if (!propertyPopup.address1) {
            errors.address1 = "This field is mandatory";
        }
        if (!propertyPopup.city) {
            errors.city = "This field is mandatory";
        }
        if (!propertyPopup.postCode) {
            errors.postCode = "This field is mandatory";
        }
        setPopupErrors(errors);
        if (Object.keys(errors).length == 0) {
            const tempRows = [...farmRows];
            tempRows[propertyPopup.id].name = propertyPopup.name;
            tempRows[propertyPopup.id].address1 = propertyPopup.address1;
            tempRows[propertyPopup.id].address2 = propertyPopup.address2;
            tempRows[propertyPopup.id].city = propertyPopup.city;
            tempRows[propertyPopup.id].postCode = propertyPopup.postCode;
            tempRows[propertyPopup.id].regionalCouncil = propertyPopup.regionalCouncil;
            tempRows[propertyPopup.id].catchment = propertyPopup.catchment;
            setFarmRows(tempRows);
            setPropertyPopup({ ...propertyPopup, showPropertyPopup: false, id: 0, name: '', address1: '', address2: '', city: '', postCode: '', regionalCouncil: null, catchment: null })
        }
        else {
            return false;
        }
    }

    function handleInputChange(event) {
        const { name, value, checked, type } = event.target;
        setPropertyPopup({ ...propertyPopup, [name]: type == 'checkbox' ? checked : value });
    }

    const [saving, setSaving] = useState('');

    return (
        <main>
            {transactionLoading && <Loading loading background="none" loaderColor="#3498db" />}
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow" container light style={{
                }}>
                    <div className="logo-farm-name">
                        <div className="header-logo" style={{marginLeft:"20vw"}}>
                            <a href="javascript:void(0);"><img className="logo" src="/images/fwfp-logo.png" /></a>
                        </div>
                    </div>
                    <div className="logo-farm-name" >
                        <Button id="checkout-and-portal-button" style={{ marginRight: "20vw", background: "none", color: "#1A959E" }} className="buttonSignupHeader" onClick={BackToMainPage} type="button">
                            &lt;Back to main website
                        </Button>
                    </div>
                </Navbar>
                <div style={{
                    backgroundImage: `url(${headerImage})`,
                    backgroundSize: 'unset',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right',
                    height: '6vh', marginTop: "0px"
                }}><span style={{ marginLeft: "20vw", fontSize: "25px", color: "white" }}><b>New Property Subscription Signup</b></span>
                </div>
            </header>
            {loading ? <SpinnerContainer /> : <>
                <div style={{ height: "83vh", overflow: "auto", marginBottom: "0vh" }}>
                    <Card className="login-card">
                        <CardBody>
                            <Row>
                                <Col sm="2">
                                </Col>
                                <Col sm="8">
                                    <Row>
                                        <Col>
                                            <Label style={{ fontWeight: "600", fontSize: "14px", textTransform: "none" }}>
                                                Please fill in the form below
                                            </Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Label style={{ fontWeight: "900", fontSize: "20px" }}>
                                                Your Details
                                            </Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label for="firstName" style={{ fontWeight: "600" }}>
                                                    First Name<span style={{ color: "red" }}>*</span>
                                                </Label>
                                                <Input
                                                    id="firstName"
                                                    name="firstName"
                                                    autoComplete="off"
                                                    type="text"
                                                    value={signupForm.firstName}
                                                    onChange={(e) => setSignupForm({ ...signupForm, firstName: e.target.value })}
                                                    required
                                                />
                                            </FormGroup>
                                            {formErrors.firstName != undefined && !signupForm.firstName &&
                                                <p className="errorMessage">{formErrors.firstName}</p>
                                            }
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label for="surName" style={{ fontWeight: "600" }}>
                                                    Surname<span style={{ color: "red" }}>*</span>
                                                </Label>
                                                <Input
                                                    id="surName"
                                                    name="surName"
                                                    autoComplete="off"
                                                    type="text"
                                                    value={signupForm.surName}
                                                    onChange={(e) => setSignupForm({ ...signupForm, surName: e.target.value })}
                                                    required
                                                />
                                            </FormGroup>
                                            {formErrors.surName != undefined && !signupForm.surName &&
                                                <p className="errorMessage">{formErrors.surName}</p>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label for="email" style={{ fontWeight: "600" }}>
                                                    Email<span style={{ color: "red" }}>*</span>
                                                </Label>
                                                <Input
                                                    id="email"
                                                    name="email"
                                                    autoComplete="off"
                                                    type="text"
                                                    value={signupForm.email}
                                                    onChange={(e) => setSignupForm({ ...signupForm, email: e.target.value })}
                                                    required
                                                />
                                            </FormGroup>
                                            {formErrors.email != undefined && (!signupForm.email || !signupForm.email.match(isValidEmail)) &&
                                                <p className="errorMessage">{formErrors.email}</p>
                                            }
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label for="mobilePhone" style={{ fontWeight: "600" }}>
                                                    Mobile Phone<span style={{ color: "red" }}>*</span>
                                                </Label>
                                                <Input
                                                    id="mobilePhone"
                                                    name="mobilePhone"
                                                    autoComplete="off"
                                                    type="text"
                                                    value={signupForm.mobilePhone}
                                                    onChange={(e) => setSignupForm({ ...signupForm, mobilePhone: e.target.value })}
                                                    required
                                                />
                                            </FormGroup>
                                            {formErrors.mobilePhone != undefined && !signupForm.mobilePhone &&
                                                <p className="errorMessage">{formErrors.mobilePhone}</p>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Label style={{ fontWeight: "600", fontSize: "14px", textTransform: "none" }}>
                                                Please note if you are an existing user in the system the new property will be added to your existing profile. Please check your email for details.
                                            </Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <Label style={{ fontWeight: "900", fontSize: "20px" }}>
                                                Property Detail
                                            </Label>
                                        </Col>
                                    </Row>
                                    {farmRows.length == 1 &&
                                        <div id="singleFarmView">
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="text-capitalize">Property Name<span style={{ color: "red" }}>*</span></Label>
                                                        <Input type="text" name="name" id="name" onChange={handlePropertyNameChange(0)} value={farmRows[0].name} />
                                                    </FormGroup>
                                                    {farmErrors.length > 0 && farmErrors[0] != undefined && farmErrors[0].name != undefined && !farmRows[0].name &&
                                                        <p className="errorMessage">{farmErrors[0].name}</p>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label className="text-capitalize">Address 1<span style={{ color: "red" }}>*</span></Label>
                                                        <Input type="text" name="address1" id="address1" onChange={handlePropertyAddress1Change(0)} value={farmRows[0].address1} />
                                                    </FormGroup>
                                                    {farmErrors.length > 0 && farmErrors[0] != undefined && farmErrors[0].address1 != undefined && !farmRows[0].address1 &&
                                                        <p className="errorMessage">{farmErrors[0].address1}</p>
                                                    }
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label className="text-capitalize">Address 2</Label>
                                                        <Input type="text" name="address2" id="address2" onChange={handlePropertyAddress2Change(0)} value={farmRows[0].address2} />
                                                    </FormGroup>
                                                    {farmErrors.length > 0 && farmErrors[0] != undefined && farmErrors[0].address2 != undefined && !farmRows[0].address2 &&
                                                        <p className="errorMessage">{farmErrors[0].address2}</p>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label className="text-capitalize">City<span style={{ color: "red" }}>*</span></Label>
                                                        <Input type="text" name="city" id="city" onChange={handlePropertyCityChange(0)} value={farmRows[0].city} />
                                                    </FormGroup>
                                                    {farmErrors.length > 0 && farmErrors[0] != undefined && farmErrors[0].city != undefined && !farmRows[0].city &&
                                                        <p className="errorMessage">{farmErrors[0].city}</p>
                                                    }
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label className="text-capitalize">Post Code<span style={{ color: "red" }}>*</span></Label>
                                                        <Input type="text" name="postCode" id="postCode" onChange={handlePropertyPostCodeChange(0)} value={farmRows[0].postCode} />
                                                    </FormGroup>
                                                    {farmErrors.length > 0 && farmErrors[0] != undefined && farmErrors[0].postCode != undefined && !farmRows[0].postCode &&
                                                        <p className="errorMessage">{farmErrors[0].postCode}</p>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row style={{ display: "none" }}>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="text-capitalize">Regional Council</Label>
                                                        {regionalCouncilList == undefined && <p><em>Loading...</em></p>}
                                                        {regionalCouncilList != undefined && regionalCouncilList != null &&
                                                            <Input type="select" value={farmRows[0].regionalCouncil} onChange={handlePropertyRegionalCouncilChange(0)} name="regionalCouncil" id="regionalCouncil">
                                                                {regionalCouncilList.map(items =>
                                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                                )}
                                                            </Input>
                                                        }
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row style={{ display: "none" }}>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="text-capitalize">Catchment</Label>
                                                        {catchmentList.filter(x => x.parentId == farmRows[0].regionalCouncil) == undefined && <p><em>Loading...</em></p>}
                                                        {catchmentList.filter(x => x.parentId == farmRows[0].regionalCouncil) != undefined && catchmentList.filter(x => x.parentId == farmRows[0].regionalCouncil) != null &&
                                                            <Input type="select" value={farmRows[0].catchment} onChange={handlePropertyCatchmentChange(0)} name="catchment" id="catchment">
                                                                <option key={uuid()} value={0} >Select</option>
                                                                {catchmentList.filter(x => x.parentId == farmRows[0].regionalCouncil).map(items =>
                                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                                )}
                                                            </Input>
                                                        }
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            {/* {farmRows[0].name && farmRows[0].address1 && farmRows[0].city && farmRows[0].postCode &&
                                                <Row>
                                                    <Col sm="12">
                                                        <button onClick={handlefarmRowsAddRow} style={{ float: "right" }} type="button" id="btnUpdate" className="btn btn-sm btn-pluse">
                                                            Add Another Property
                                                        </button>
                                                    </Col>
                                                </Row>
                                            } */}
                                        </div>
                                    }
                                    {
                                        farmRows.length > 1 &&
                                        <div id="multiFarmView">
                                            <Row style={{ marginTop: "10px" }}>
                                                <Col sm="12">
                                                    <table style={{ float: "none", marginTop: "-10px", backgroundColor: "white" }} className="table table-bordered table-hover" id="tab_logic">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center"> # </th>
                                                                <th className="text-left"> Property Name </th>
                                                                <th />
                                                                <th />
                                                            </tr>
                                                        </thead>
                                                        <tbody className="text-left">
                                                            {farmRows.map((item, idx) => (
                                                                <tr id="addr0" key={idx}>
                                                                    <td style={{ display: "none" }}>{farmRows[idx].id}</td>
                                                                    <td className="text-center" style={{ width: "10%" }}>
                                                                        {parseInt(idx) + 1}
                                                                    </td>
                                                                    <td style={{ width: "50%" }}>
                                                                        {farmRows[idx].name}
                                                                    </td>
                                                                    <td style={{ width: "10%" }} className="text-center">
                                                                        <>
                                                                            <button style={{ float: "center" }} onClick={handlePropertyPopupOpen(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-success">
                                                                                <FaEdit />
                                                                            </button>
                                                                        </>
                                                                    </td>
                                                                    <td style={{ width: "10%" }} className="text-center">
                                                                        <>
                                                                            <button style={{ float: "center " }} onClick={handlefarmRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                                <FaTrash />
                                                                            </button>
                                                                        </>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </Col>
                                            </Row>
                                            {/* {!conditions &&
                                                <Row>
                                                    <Col sm="12">
                                                        <button onClick={handlefarmRowsAddRow} style={{ float: "right" }} type="button" id="btnUpdate" className="btn btn-sm btn-pluse">
                                                            Add Another Property
                                                        </button>
                                                    </Col>
                                                </Row>
                                            } */}
                                        </div>
                                    }
                                    <Row>
                                        <Col>
                                            <Label style={{ fontWeight: "600", fontSize: "14px", textTransform: "none" }}>
                                               If you are not sure of your catchment, please select "Unknown". We will follow up and try to identity the catchment from the property location. We will be in touch with any changes.
                                            </Label>
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: "5px" }}>
                                        <Col sm="6">
                                            <Input type="checkbox" checked={conditions} onChange={(e) => handleChangeConditions(e)} name="conditions" id="conditions" />&nbsp;&nbsp;
                                            <Label style={{ fontWeight: "700", fontSize: "14px", textTransform: "none" }}>I have read and accept the <a href="https://freshwaterfarmplan.co.nz/terms-and-conditions-qconzfwfp-tool/" target="_blank">Terms and Conditions</a></Label><br />
                                        </Col>
                                    </Row>
                                    <Row style={{marginTop:"10px"}}>
                                        <Col>
                                            <Label style={{ fontWeight: "900", fontSize: "20px" }}>
                                                Subscription (select)
                                            </Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="4">
                                            <Input type="checkbox" checked={annual} disabled={true} onChange={(e) => handleAnnualChange(e)} name="annual" id="annual" />&nbsp;&nbsp;
                                            <Label style={{ fontWeight: "900", fontSize: "16px" }}>Annual - ${annualCharge} + GST</Label><br />
                                            <span style={{ marginLeft: "1.25vw" }}>Charged automatically each year on this date</span>
                                        </Col>
                                        <Col sm="4" style={{ display:"none" }}>
                                            <Input type="checkbox" checked={monthly} onChange={(e) => handleMonthlyChange(e)} name="monthly" id="monthly" />&nbsp;&nbsp;
                                            <Label style={{ fontWeight: "900", fontSize: "16px" }}>Monthly - ${monthlyCharge}+ GST</Label><br />
                                            <span>Charged on the same date each month</span>
                                        </Col>
                                    </Row>
                                    <Row style={{ backgroundColor: "rgba(82, 175, 181, 0.18)", marginTop: "10px" }}>
                                        <Col sm="8">
                                            <Row>
                                                <Col sm="6">
                                                    <Label className="text-capitalize" style={{ fontWeight: "800", fontSize: "16px" }}>
                                                        Checkout
                                                    </Label>
                                                </Col>
                                            </Row>
                                            <Row style={{ marginTop: "10px" }}>
                                                <Col sm="6">
                                                    <table style={{ float: "none", marginTop: "-10px", backgroundColor: "white" }} className="table table-bordered table-hover" id="tab_logic">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center"> # Properties </th>
                                                                <th className="text-center"> Subscription </th>
                                                                <th className="text-center"> $ </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="text-center">
                                                            <tr>
                                                                <td style={{ border: "solid 1px #dee2e6" }}>
                                                                    {farmRows.length > 0 ? farmRows.length : ''}
                                                                </td>
                                                                <td style={{ border: "solid 1px #dee2e6" }}>
                                                                    {annual == true ? 'Annual' : (monthly == true ? 'Monthly' : '')}
                                                                </td>
                                                                <td style={{ border: "solid 1px #dee2e6" }}>
                                                                    {annual == true ? (farmRows.length > 0 ? farmRows.length * annualCharge : '') : (monthly == true ? (farmRows.length > 0 ? (Math.round(farmRows.length * monthlyCharge * 100) / 100) : '') : '')}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ border: "solid 1px #dee2e6" }}>

                                                                </td>
                                                                <td style={{ border: "solid 1px #dee2e6" }}>
                                                                    GST
                                                                </td>
                                                                <td style={{ border: "solid 1px #dee2e6" }}>
                                                                    {annual == true ? (farmRows.length > 0 ? Math.round((farmRows.length * annualCharge * (gst / 100)) * 100) / 100 : '') : (monthly == true ? (farmRows.length > 0 ? (Math.round((Math.round(farmRows.length * monthlyCharge * 100) / 100) * (gst / 100) * 100) / 100) : '') : '')}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2">Total Annual Charge</td>
                                                                <td>{farmRows.length > 0 ?
                                                                    (annual == true ? (farmRows.length > 0 ? (farmRows.length * annualCharge) + (Math.round((farmRows.length * annualCharge * (gst / 100)) * 100) / 100) : 0) : (monthly == true ? (farmRows.length > 0 ? Math.round(((farmRows.length * monthlyCharge) + ((farmRows.length * monthlyCharge) * (gst / 100))) * 100) / 100 : 0) : 0))
                                                                    : ''}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2">Will be charged each year on this date
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </Col>
                                            </Row>
                                            <Row style={{ marginTop: "5px", marginBottom: "5px" }}>
                                                <Col sm="6">
                                                    <Input type="checkbox" checked={isAutoRenew} onChange={(e) => setAutoRenew(e.target.checked)} name="conditions" id="conditions" />&nbsp;&nbsp;
                                                    <Label style={{ fontWeight: "700", fontSize: "14px", textTransform: "none" }}>Auto renew </Label><br />
                                                </Col>
                                            </Row>
                                            
                                        </Col>
                                        <Col sm="4">
                                            <Row style={{ marginTop: "10vh" }}>
                                                {farmRows.length > 0 && conditions &&
                                                    <Col sm="6" >
                                                        <div>
                                                            <form>
                                                                {/* Add a hidden field with the lookup_key of your Price */}
                                                                <input type="hidden" name="lookup_key" value="prod_PzFuEwVSIdQtnd" />
                                                                {/*<button className="buttonStripe" onClick={CreateCheckoutSession} id="checkout-and-portal-button" type="button">*/}
                                                                {/*    Checkout*/}
                                                                {/*</button>*/}

                                                                {saving ?
                                                                    <Button id="checkout-and-portal-button" className="buttonStripe" onClick={CreateCheckoutSession} type="button"
                                                                        disabled
                                                                    >
                                                                        <Row>
                                                                            <Col sm="6">
                                                                                <span>
                                                                                    {' '}Processing
                                                                                </span>
                                                                            </Col>
                                                                            <Col sm="6">
                                                                                <Spinner size="sm">
                                                                                    Processing...
                                                                                </Spinner>
                                                                            </Col>
                                                                        </Row>
                                                                    </Button>
                                                                    :
                                                                    <Button id="checkout-and-portal-button" className="buttonStripe" onClick={CreateCheckoutSession} type="button">
                                                                        Checkout
                                                                    </Button>
                                                                }

                                                            </form>
                                                        </div>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                    </Row>
                                    <br />
                                </Col>
                                <Col sm="2">
                                </Col>
                            </Row>
                            
                        </CardBody>
                    </Card>

                    <Modal isOpen={propertyPopup.showPropertyPopup}>
                        <ModalHeader toggle={handlePropertyPopupClose} >Edit Property Details</ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label className="text-capitalize">Property Name<span style={{ color: "red" }}>*</span></Label>
                                        <Input type="text" name="name" id="name" onChange={handleInputChange} value={propertyPopup.name} />
                                    </FormGroup>
                                    {popupErrors.name != undefined &&
                                        <p className="errorMessage">{popupErrors.name}</p>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label className="text-capitalize">Address 1<span style={{ color: "red" }}>*</span></Label>
                                        <Input type="text" name="address1" id="address1" onChange={handleInputChange} value={propertyPopup.address1} />
                                    </FormGroup>
                                    {popupErrors.address1 != undefined &&
                                        <p className="errorMessage">{popupErrors.address1}</p>
                                    }
                                </Col>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label className="text-capitalize">Address 2</Label>
                                        <Input type="text" name="address2" id="address2" onChange={handleInputChange} value={propertyPopup.address2} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label className="text-capitalize">City<span style={{ color: "red" }}>*</span></Label>
                                        <Input type="text" name="city" id="city" onChange={handleInputChange} value={propertyPopup.city} />
                                    </FormGroup>
                                    {popupErrors.city != undefined &&
                                        <p className="errorMessage">{popupErrors.city}</p>
                                    }
                                </Col>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label className="text-capitalize">Post Code<span style={{ color: "red" }}>*</span></Label>
                                        <Input type="text" name="postCode" id="postCode" onChange={handleInputChange} value={propertyPopup.postCode} />
                                    </FormGroup>
                                    {popupErrors.postCode != undefined &&
                                        <p className="errorMessage">{popupErrors.postCode}</p>
                                    }
                                </Col>
                            </Row>
                            <Row style={{ display: "none" }}>
                                <Col>
                                    <FormGroup>
                                        <Label className="text-capitalize">Regional Council</Label>
                                        {regionalCouncilList == undefined && <p><em>Loading...</em></p>}
                                        {regionalCouncilList != undefined && regionalCouncilList != null &&
                                            <Input type="select" value={propertyPopup.regionalCouncil} onChange={handleInputChange} name="regionalCouncil" id="regionalCouncil">
                                                {regionalCouncilList.map(items =>
                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row style={{ display: "none" }}>
                                <Col>
                                    <FormGroup>
                                        <Label className="text-capitalize">Catchment</Label>
                                        {catchmentList == undefined && <p><em>Loading...</em></p>}
                                        {catchmentList != undefined && catchmentList != null &&
                                            <Input type="select" value={propertyPopup.catchment} onChange={handleInputChange} name="catchment" id="catchment">
                                                {catchmentList.map(items =>
                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handlePropertyPopupSave}>Update</Button>
                            <Button color="danger" onClick={handlePropertyPopupClose}>Cancel</Button>
                        </ModalFooter>
                    </Modal>

                </div>
            </>}
            <div className="footerSignup">
                <Navbar className="navbar1 navbar-expand-sm navbar-toggleable-sm ng-white box-shadow" light style={{
                    paddingTop:"0rem",paddingBottom:"0rem"
                }}>
                    <Row>
                        <Col sm="4">
                            <div className="logo-farm-name">
                                <div className="header-logo" style={{ marginLeft: "20vw", background: "none" }}>
                                    <a href="javascript:void(0);"><img width="300" height="65" className="logo" src="/images/FWFP-logo_white.png" /></a>
                                </div>
                            </div>
                        </Col>
                        <Col sm="2" style={{ marginLeft: "8vw" }}>
                            <div className="logo-farm-name" style={{}}>
                                <Button id="checkout-and-portal-button" style={{ background: "none", color: "white", fontSize: "13px" }} className="buttonSignupHeader" onClick={BackToMainPage} type="button">
                                    &lt;Back to main website
                                </Button>
                            </div>
                        </Col>
                        <Col sm="4">
                            <div className="logo-farm-name" style={{marginLeft:"3vw"}}>
                                <Row>
                                    <Col sm="12" style={{ color: "white", fontSize: "13px", fontWeight: "500" }}>
                                        QCONZ Support
                                    </Col>
                                    <Col sm="12" style={{ color: "white", fontSize: "13px", fontWeight: "500" }}>
                                        0800 726 695
                                    </Col>
                                    <Col sm="12" style={{ color: "white", marginTop: "5px", fontSize: "13px", fontWeight: "500" }}>
                                        QCONZ FWFP
                                    </Col>
                                    <Col sm="12">
                                        <Button id="checkout-and-portal-button" style={{ background: "none", fontSize: "13px", color: "white", marginTop: "-5px" }} className="buttonSignupHeader" onClick={BackToSupportGuides} type="button">
                                            Support Guides
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col sm="4">
                        </Col>
                        <Col sm="6" style={{ color: "white", fontSize: "13px", fontWeight: "500", display: "flex", marginLeft: "10vw" }}>
                            @Copyright 2024 | Developed by QCONZ
                            {/*<Button id="checkout-and-portal-button" style={{ border: "none", marginLeft: "-15px", background: "none", marginTop: "-8px", color: "white" }} className="" onClick={BackToTerms} type="button">*/}
                            {/*    &nbsp;Terms & Conditions*/}
                            {/*</Button>*/}
                        </Col>
                    </Row>                    
                </Navbar>
            </div>
        </main>
    )
}
export default Signup;